<div class="diagram">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 528 555">
    <g
      id="Pickup_truck_single_cabin"
      data-name="Pickup truck single cabin"
      transform="translate(-434 -124)"
    >
      <text
        id="Pickup_truck_single_cabin-2"
        data-name="Pickup truck
          single cabin"
        transform="translate(688 137)"
        font-size="14"
        font-family="Roboto-Bold, Roboto"
        font-weight="700"
      >
        <tspan x="-41.125" y="0">Truck Single Cabin</tspan>
      </text>
      <g id="Elements_" data-name="Elements " transform="translate(269.548 -55.85)">
        <path
          id="Path_827"
          data-name="Path 827"
          d="M396.5,699.177s-1.3-.3-1.712,1.34-2.01,7.855-2.01,7.855v96.121s.075.856.67.819,1.973,0,1.973,0Z"
          transform="translate(-29.274 -320.064)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_790"
          data-name="Path 790"
          d="M614.527,299.591h36.185s-3.462-3.5-5.919-3.946h-7.3s-1.3-1.3-4.949-1.3c0,0-3.158-.114-4.949,1.3h-7.785S614.676,297.209,614.527,299.591Z"
          transform="translate(-195.305 -16.971)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_792"
          data-name="Path 792"
          d="M571.712,298.379l8.339-1.117h42.29l7.148.558-7.148-5.1a29.717,29.717,0,0,0-8.264-1.489H585.337s-7.818,1.34-8.562,2.085Z"
          transform="translate(-163.248 -14.641)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1067" data-name="Group 1067" transform="translate(371.367 278.675)">
          <path
            id="Path_795"
            data-name="Path 795"
            d="M510.318,309.793c.175-.073,3.067-6.543,3.067-6.543a78.253,78.253,0,0,1,17.422-3.723l-2.867,2.866-13.271,2.755-1.7,3.551Z"
            transform="translate(-488.648 -299.528)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1068" data-name="Group 1068" transform="translate(458.785 277.848)">
          <path
            id="Path_797"
            data-name="Path 797"
            d="M774.42,298l15.283,4.132,1.759,4.31,2.678,1.106-3.072-7s-10.473-3.232-16.919-3.474a4.926,4.926,0,0,0-2.176-.826"
            transform="translate(-771.973 -296.239)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_801"
          data-name="Path 801"
          d="M497.636,400.041s10.945-60.531,16.975-71.476"
          transform="translate(-107.786 -42.594)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_802"
          data-name="Path 802"
          d="M824.273,400.041S813.329,339.51,807.3,328.565"
          transform="translate(-339.637 -42.594)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_806"
          data-name="Path 806"
          d="M479.265,686.415s12.992-5.4,52.081-5.4c0,0,47.837,1.526,52.3,5.4"
          transform="translate(-94.031 -306.483)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_811"
          data-name="Path 811"
          d="M903.426,823.895l8.711-1.9s3.015-.447,3.015-2.569-.261-72-.261-72,.037-2.718-2.383-.782-11.242,34.249-11.242,43.7-.67,29.335-.67,29.335S900.373,823.187,903.426,823.895Z"
          transform="translate(-409.489 -355.102)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_813"
          data-name="Path 813"
          d="M965.5,699.177s1.3-.3,1.712,1.34,2.01,7.855,2.01,7.855v96.121s-.074.856-.67.819-1.973,0-1.973,0Z"
          transform="translate(-458.084 -320.064)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_814"
          data-name="Path 814"
          d="M962.312,1001.961c.028-.14.14-7.455.14-7.455l.782-.475V987.61l-.921-.865v-5.165l2.662,3.546-.149,13.709Z"
          transform="translate(-455.699 -531.521)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_817"
          data-name="Path 817"
          d="M910.965,1086.187s-15.661-.894-17.072-1.861a4.719,4.719,0,0,1-2.249-4.467v-4.6l19.321-2.457Z"
          transform="translate(-402.789 -599.822)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_818"
          data-name="Path 818"
          d="M901.9,860.085s11.675-2.457,11.477-4.579,0-58.98,0-58.98l-2.654,1.037.612,55.215s.728.829-1.506,1.834-9.418,2.941-9.418,2.941S899.863,860.554,901.9,860.085Z"
          transform="translate(-409.301 -392.967)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_819"
          data-name="Path 819"
          d="M921.089,866.474a13.152,13.152,0,0,0,1.107-3.8V810.131"
          transform="translate(-424.835 -403.154)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_820"
          data-name="Path 820"
          d="M902.856,956.8h5.689v5.137h-5.689Z"
          transform="translate(-411.184 -512.97)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_49"
          data-name="Line 49"
          x2="0.112"
          y2="4.691"
          transform="translate(493.378 444.279)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_821"
          data-name="Path 821"
          d="M891,945.853v3.034s.223,1.675-1.284,1.675h-2.178l-1.731,2.01h2.178l-3.993,3.993h-6.338l-7.092-3.211h-4.076v.53h-.307l.307-.14V942.354h-.614l1.919-54.557.042-2.425-.035,2s3.211.7,3.211,1.4l-.875,34.038s-.031,3.2,1.7,3.426"
          transform="translate(-382.823 -459.488)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_822"
          data-name="Path 822"
          d="M903.44,691.832s-13.513,39.881-14.463,52.03"
          transform="translate(-400.792 -314.581)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_823"
          data-name="Path 823"
          d="M872.458,1124.467h7.069v-5.807"
          transform="translate(-388.424 -634.156)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_824"
          data-name="Path 824"
          d="M876.9,1130.746h11.019V1122.3"
          transform="translate(-391.752 -636.88)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_825"
          data-name="Path 825"
          d="M426.28,823.895l-8.711-1.9s-3.016-.447-3.016-2.569.261-72,.261-72-.037-2.718,2.382-.782,11.243,34.249,11.243,43.7.67,29.335.67,29.335S429.332,823.187,426.28,823.895Z"
          transform="translate(-45.58 -355.102)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_828"
          data-name="Path 828"
          d="M402.845,1001.961c-.028-.14-.14-7.455-.14-7.455l-.782-.475V987.61l.921-.865v-5.165l-2.662,3.546.149,13.709Z"
          transform="translate(-34.82 -531.521)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_831"
          data-name="Path 831"
          d="M404.553,1086.187s15.661-.894,17.072-1.861a4.719,4.719,0,0,0,2.249-4.467v-4.6l-19.321-2.457Z"
          transform="translate(-38.092 -599.822)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_832"
          data-name="Path 832"
          d="M432.349,860.085s-11.675-2.457-11.477-4.579,0-58.98,0-58.98l2.654,1.037-.612,55.215s-.728.829,1.506,1.834,9.419,2.941,9.419,2.941S434.384,860.554,432.349,860.085Z"
          transform="translate(-50.309 -392.967)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_833"
          data-name="Path 833"
          d="M448.7,866.474a13.148,13.148,0,0,1-1.108-3.8V810.131"
          transform="translate(-70.316 -403.154)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_834"
          data-name="Path 834"
          d="M453.28,956.8h-5.689v5.137h5.689Z"
          transform="translate(-70.316 -512.97)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_50"
          data-name="Line 50"
          x1="0.112"
          y2="4.691"
          transform="translate(381.147 444.279)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_835"
          data-name="Path 835"
          d="M404.518,945.853v3.034s-.223,1.675,1.284,1.675h2.178l1.731,2.01h-2.178l3.993,3.993h6.338l7.092-3.211h4.076v.53h.307l-.307-.14V942.354h.614L427.728,887.8l-.042-2.425.035,2s-3.211.7-3.211,1.4l.875,34.038s.031,3.2-1.7,3.426"
          transform="translate(-38.058 -459.488)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_836"
          data-name="Path 836"
          d="M426.554,691.832s13.513,39.881,14.462,52.03"
          transform="translate(-54.565 -314.581)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_837"
          data-name="Path 837"
          d="M479.565,1124.467H472.5v-5.807"
          transform="translate(-88.962 -634.156)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_838"
          data-name="Path 838"
          d="M463.351,1130.746H452.332V1122.3"
          transform="translate(-73.866 -636.88)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g id="Group_1069" data-name="Group 1069" transform="translate(506.892 491.074)">
          <path
            id="Path_841"
            data-name="Path 841"
            d="M964.045,1182.7h1.787s.981-.052.981-.516,1.213-9.161-2.89-14.864Z"
            transform="translate(-963.797 -1161.661)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g id="Group_1070" data-name="Group 1070" transform="translate(362.757 491.074)">
          <path
            id="Path_843"
            data-name="Path 843"
            d="M399.932,1182.7h-1.787s-.98-.052-.98-.516-1.213-9.161,2.89-14.864Z"
            transform="translate(-395.192 -1161.661)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <path
          id="Path_845"
          data-name="Path 845"
          d="M426,1162.646V1325.74s-1.418,4.914,5.059,4.914"
          transform="translate(-54.05 -667.09)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_846"
          data-name="Path 846"
          d="M930.6,1162.646V1325.74s1.419,4.914-5.059,4.914"
          transform="translate(-428.167 -667.09)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <line
          id="Line_51"
          data-name="Line 51"
          x2="130.084"
          transform="translate(371.948 658.65)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_847"
          data-name="Path 847"
          d="M417.634,1823.938a26.237,26.237,0,0,1,3.8-1.564,25.455,25.455,0,0,1,3.462,1.117H543.058l4.535-1.117,4.654,1.564"
          transform="translate(-47.886 -1161.043)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <path
          id="Path_848"
          data-name="Path 848"
          d="M407.527,1662.519v38.046s-.6,3.686,4.593,5.138l5.191,1.452h13.6l.8.8h90.756l1.21-1.132h12.806s11.317-1.116,11.242-4.02v-40.28"
          transform="translate(-40.304 -1041.356)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_rr_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="129"
          height="18"
          rx="9"
          transform="translate(434 590)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 590)"
        />
        <g class="arrow" id="Arrow">
          <path
            id="Path_436"
            data-name="Path 436"
            d="M6241,992.9l-67.429-13.243H6157"
            transform="translate(-5594.999 -384.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_158"
            data-name="Ellipse 158"
            cx="3"
            cy="3"
            r="3"
            transform="translate(643 605)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Indicator_Lamp-2"
          data-name="LFT RR Indicator Lamp"
          d="M414.611,1824.036l4.557-1.662,3.462,1.117h8.823v3.35H422.63S415.6,1825.069,414.611,1824.036Z"
          transform="translate(223.925 -1216.893)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Indicator_Lamp-3"
          data-name="LFT RR Indicator Lamp"
          transform="translate(528 602)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-91.523" y="0">
            {{ 'exterior.pickup_single_cabin.lft_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(547 601)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_bumper'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rr_bumpher' | translate"
      >
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="108"
          height="18"
          rx="9"
          transform="translate(455 620)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 620)"
        />
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Path_437"
            data-name="Path 437"
            d="M6253,979.652l-77.062,11.542H6157"
            transform="translate(-5594.999 -362.652)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_157"
            data-name="Ellipse 157"
            cx="3"
            cy="3"
            r="3"
            transform="translate(655 614)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="RR_Bumpher-2" data-name="RR Bumpher">
          <path
            id="Path_849"
            data-name="Path 849"
            d="M792.753,1832.3s4.318,6.165,8.339,6.016,25.724,0,25.724,0,6.664-.149,7.334-1.713,1-8,1-8-3.528,1.973-10.229,2.569H812.111l-1.21,1.132Z"
            transform="translate(-59.198 -1221.553)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_850"
            data-name="Path 850"
            d="M408.817,1825.034s-1.217,9.716,4.2,9.939H418.2l25.463.894,7.259-6.351H432.6l-.8-.8H418.2s-7.131-1.645-8.019-2.8l-.994-1.032Z"
            transform="translate(228.351 -1218.771)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="RR_Bumpher-3"
          data-name="RR Bumpher"
          transform="translate(538 633)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-60.601" y="0">
            {{ 'exterior.pickup_single_cabin.rr_bumpher' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(547 632)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_cargo_deck'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rr_cargo_deck' | translate"
      >
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="114"
          height="18"
          rx="9"
          transform="translate(448 471)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(544 471)"
        />
        <g id="Group_1337" data-name="Group 1337">
          <path
            id="Path_432"
            data-name="Path 432"
            d="M6276.034,1006.652l-95.554-27H6157"
            transform="translate(-5594.999 -500.652)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_162"
            data-name="Ellipse 162"
            cx="3"
            cy="3"
            r="3"
            transform="translate(678 503)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Cargo_Deck_2"
          data-name="RR Cargo Deck "
          d="M436.476,1333.9h17.936l1.9,1.9h80.969v-1.9h18.092V1205.358h3.536l-2.9-20.326H435.454l-2.708,20.549h4.284Z"
          transform="translate(210.348 -739.7)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Cargo_Deck_3"
          data-name="RR Cargo Deck "
          transform="translate(538 483)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-74.028" y="0">
            {{ 'exterior.pickup_single_cabin.rr_cargo_deck' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(546 482)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['roll_over_bar'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.roll_over_bar' | translate"
      >
        <g
          class="parts"
          id="Roll_Over_Bar-2"
          data-name="Roll Over Bar"
          transform="translate(269.548 -55.85)"
        >
          <path
            id="Path_854"
            data-name="Path 854"
            d="M437.85,1214.341H561.129l-.413-4.612H438.338Z"
            transform="translate(-63.022 -702.342)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_855"
            data-name="Path 855"
            d="M488.535,1242.984v-14.46h3.276v14.46l-1.035,9.977h-3.307Z"
            transform="translate(-100.173 -716.414)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_856"
            data-name="Path 856"
            d="M864.885,1242.984v-14.46h3.276v14.46l-1.035,9.977h-3.307Z"
            transform="translate(-381.956 -716.414)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="108"
          height="18"
          rx="9"
          transform="translate(455 443)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 443)"
        />
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_431"
            data-name="Path 431"
            d="M6254.828,995.573,6176.3,979.652H6157"
            transform="translate(-5594.999 -528.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_163"
            data-name="Ellipse 163"
            cx="3"
            cy="3"
            r="3"
            transform="translate(655 464)"
            fill="#696969"
          />
        </g>
        <text
          id="Roll_Over_Bar-3"
          data-name="Roll Over Bar"
          transform="translate(538 455)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-62.925" y="0">
            {{ 'exterior.pickup_single_cabin.roll_over_bar' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(547 454)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_panel'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(456 501)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(544 501)"
        />
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_433"
            data-name="Path 433"
            d="M6229.219,988.11l-57.973-8.458H6157"
            transform="translate(-5594.999 -469.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_161"
            data-name="Ellipse 161"
            cx="3"
            cy="3"
            r="3"
            transform="translate(631 516)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Panel_2"
          data-name="LFT RR Panel "
          d="M394.279,1274.9l.521-130.089-3.872,3.853-1.117,117.3Z"
          transform="translate(242.493 -709.584)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Panel_3"
          data-name="LFT RR Panel "
          transform="translate(538 513)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-66.958" y="0">
            {{ 'exterior.pickup_single_cabin.lft_rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(546 512)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['other_1'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.other_1' | translate"
      >
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="75"
          height="18"
          rx="9"
          transform="translate(488 651)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Other_1-2"
          data-name="Other 1"
          transform="translate(538 663)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-32.837" y="0">
            {{ 'exterior.pickup_single_cabin.other_1' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 651)"
        />
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(547 662)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_stop_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="111"
          height="18"
          rx="9"
          transform="translate(452 561)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 561)"
        />
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_435"
            data-name="Path 435"
            d="M6255,1015.11l-78.668-35.458H6157"
            transform="translate(-5594.999 -409.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_159"
            data-name="Ellipse 159"
            cx="3"
            cy="3"
            r="3"
            transform="translate(657 603)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Stop_Lamp-2"
          data-name="LFT Stop Lamp"
          d="M6124.145,3161.925h16v3.722h-10.394l-1.029-.92h-4.579Z"
          transform="translate(-5469 -2555)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Stop_Lamp-3"
          data-name="LFT Stop Lamp"
          transform="translate(525 574)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-67.446" y="0">
            {{ 'exterior.pickup_single_cabin.lft_stop_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(547 572)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_emblem'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_rr_emblem' | translate"
      >
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="116"
          height="18"
          rx="9"
          transform="translate(447 530)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 530)"
        />
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <path
            id="Path_434"
            data-name="Path 434"
            d="M6235.612,1017.673l-63.606-38.021H6157"
            transform="translate(-5594.999 -439.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_160"
            data-name="Ellipse 160"
            cx="3"
            cy="3"
            r="3"
            transform="translate(638 576)"
            fill="#696969"
          />
        </g>
        <rect
          class="parts"
          id="LFT_RR_Emblem-2"
          data-name="LFT RR Emblem"
          width="15.792"
          height="2.599"
          rx="1.3"
          transform="translate(642.617 588.55) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Emblem-3"
          data-name="LFT RR Emblem"
          transform="translate(538 542)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-70.845" y="0">
            {{ 'exterior.pickup_single_cabin.lft_rr_emblem' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(547 541)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rv_mirror'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(457 382)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 382)"
        />
        <g class="parts" id="LFT_R.V_Mirror-2" data-name="LFT R.V Mirror">
          <path
            id="Path_829"
            data-name="Path 829"
            d="M418.166,767.64s-2.741.224-2.74,0,.023-6.143.023-6.143l2.717-3.419Z"
            transform="translate(223.315 -420.03)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_830"
            data-name="Path 830"
            d="M368.583,777.786l-14.351,7.65a6.233,6.233,0,0,1,.447-5.919c1.954-2.848,10.684-8.934,10.684-8.934s2.988-1.508,3.83.614v5.417A.99.99,0,0,1,368.583,777.786Z"
            transform="translate(269.548 -429.003)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <path
            id="Path_429"
            data-name="Path 429"
            d="M6217,979.656l-48.164,34.547H6157"
            transform="translate(-5593.999 -623.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_164"
            data-name="Ellipse 164"
            cx="3"
            cy="3"
            r="3"
            transform="translate(620 353)"
            fill="#696969"
          />
        </g>
        <text
          id="LFT_R.V_Mirror-3"
          data-name="LFT R.V Mirror"
          transform="translate(538 395)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-69.634" y="0">
            {{ 'exterior.pickup_single_cabin.lft_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(547 393)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_door'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_door' | translate"
        transform="translate(-5.592 10.772)"
      >
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="84"
          height="18"
          rx="9"
          transform="translate(479 352)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 352)"
        />
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_428"
            data-name="Path 428"
            d="M6234,979.656l-61.811,30.547H6157"
            transform="translate(-5593.999 -647.657)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_165"
            data-name="Ellipse 165"
            cx="3"
            cy="3"
            r="3"
            transform="translate(637 329)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Door-2"
          data-name="LFT Door"
          d="M423.874,807.523l-19.321-2.457.763-89.773s4.1-1.135,6.161,5.063,11.671,33.43,11.671,45.6Z"
          transform="translate(231.456 -387.935)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Door-3"
          data-name="LFT Door"
          transform="translate(543.592 364)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-40.703" y="0">
            {{ 'exterior.pickup_single_cabin.lft_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(547 363)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_frt_fender'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_frt_fender' | translate"
      >
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="110"
          height="18"
          rx="9"
          transform="translate(453 323)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 323)"
        />
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_427"
            data-name="Path 427"
            d="M6229.352,979.656,6171.271,991.2H6157"
            transform="translate(-5593.999 -659.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_166"
            data-name="Ellipse 166"
            cx="3"
            cy="3"
            r="3"
            transform="translate(631 317)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_FRT_Fender-2"
          data-name="LFT FRT Fender"
          d="M400.9,455.948s-1.452-9.046,3.295-11.336c0,0,.279-2.494,1.452-3.369,0,0-2.829.484-1.713-9.009l4.005-65.842-2.292,1.1-4.858,9.772s-7.092,2.513-7.818,5.863v58.856s1.843,6.7,3.406,7.259l.112,4.8S399.835,453.715,400.9,455.948Z"
          transform="translate(240.131 -126.766)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_FRT_Fender-3"
          data-name="LFT FRT Fender"
          transform="translate(538 336)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-69.868" y="0">
            {{ 'exterior.pickup_single_cabin.lft_frt_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(547 334)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['glasses'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.wind_screen' | translate"
      >
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="109"
          height="18"
          rx="9"
          transform="translate(454 293)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 293)"
        />
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_426"
            data-name="Path 426"
            d="M6309,1016.158l-122.016-36.5H6157"
            transform="translate(-5593.999 -678.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_167"
            data-name="Ellipse 167"
            cx="3"
            cy="3"
            r="3"
            transform="translate(712 336)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Wind_Screen-2"
          data-name="Glasses"
          d="M437.85,639.419l11.561,48.324s2.122,6.478,7.148,4.914c0,0,9.418-2.271,43.816-2.271,13.453,0,27.135.122,40.5,1.734,2.433.293,6.495,1.392,8.263-1.026,2.122-2.9,13.534-51.262,13.534-51.262s2.957-10.175-35.48-12.123l-22.355-.655s-38.926.336-48.782,2.431c0,0-16.868,2.045-16.812,6.922A4.151,4.151,0,0,0,437.85,639.419Z"
          transform="translate(206.526 -321.93)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Wind_Screen-3"
          data-name="Glasses"
          transform="translate(538 305)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-56.035" y="0">
            {{ 'exterior.pickup_single_cabin.wind_screen' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(547 304)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['hood'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.hood' | translate"
      >
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="68"
          height="18"
          rx="9"
          transform="translate(495 264)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 264)"
        />
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_425"
            data-name="Path 425"
            d="M6285,998.11l-102.75-18.453H6157"
            transform="translate(-5593.999 -707.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_168"
            data-name="Ellipse 168"
            cx="3"
            cy="3"
            r="3"
            transform="translate(688 288)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Hood-2"
          data-name="Hood"
          d="M469.828,316.349s-16.6,4.379-29.946,11.738l-4.005,65.842s-1.191,9.083,1.713,9.009c0,0-3.27-9.307,61.018-9.307,0,0,54.758-1.265,60.863,9.307,0,0,2.085,1.079,1.414-12.881l-1.414-60.382L527.6,315.79l-29-.558H478.166Z"
          transform="translate(208.185 -88.461)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Hood-3"
          data-name="Hood"
          transform="translate(538 276)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-29.136" y="0">
            {{ 'exterior.pickup_single_cabin.hood' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(547 275)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_head_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="109"
          height="18"
          rx="9"
          transform="translate(454 203)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 203)"
        />
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_423"
            data-name="Path 423"
            d="M6248.73,998.11l-73.636-18.453H6157"
            transform="translate(-5593.999 -767.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_170"
            data-name="Ellipse 170"
            cx="3"
            cy="3"
            r="3"
            transform="translate(652 228)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Head_Lamp-2"
          data-name="LFT Head Lamp"
          d="M424.079,327.206l4.858-9.772s10.259-5.034,19.68-8.819c4.958-1.992,9.683-3.639,12.559-4.024l5.063-5.063s-13.513.6-35.235,10.479C431,310.007,425.475,312.52,424.079,327.206Z"
          transform="translate(216.836 -76.703)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Head_Lamp-3"
          data-name="LFT Head Lamp"
          transform="translate(538 215)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-75.435" y="0">
            {{ 'exterior.pickup_single_cabin.lft_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(547 214)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.lft_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="125"
          height="18"
          rx="9"
          transform="translate(438 233)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 233)"
        />
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_424"
            data-name="Path 424"
            d="M6234.019,985.11l-61.827-5.454H6157"
            transform="translate(-5593.999 -737.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_169"
            data-name="Ellipse 169"
            cx="3"
            cy="3"
            r="3"
            transform="translate(638 245)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Indicator_lamp-5"
          data-name="LFT Indicator lamp"
          d="M424.079,363.982l4.858-9.772v-5.564S425.14,352.618,424.079,363.982Z"
          transform="translate(216.836 -113.479)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Indicator_lamp-6"
          data-name="LFT Indicator lamp"
          transform="translate(538 245)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-88.667" y="0">
            {{ 'exterior.pickup_single_cabin.lft_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(547 244)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['tires'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.tyres' | translate"
      >
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="74"
          height="18"
          rx="9"
          transform="translate(832 652)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Tyres-2"
          data-name="Tyres"
          transform="translate(855 664)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.tyres' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 652)"
        />
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(834 664)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_panel'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_rr_panel' | translate"
      >
        <g id="Group_106" data-name="Group 106" transform="translate(831.784 462)">
          <rect
            id="Rectangle_38-17"
            data-name="Rectangle 38"
            width="108"
            height="18"
            rx="9"
            transform="translate(0.216)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 462)"
        />
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_447"
            data-name="Path 447"
            d="M6157,997.656l40.938-18H6208"
            transform="translate(-5375.998 -509.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_152"
            data-name="Ellipse 152"
            cx="3"
            cy="3"
            r="3"
            transform="translate(778 485)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_RR_Panel-2"
          data-name="RHT RR Panel"
          d="M963.944,1274.9l-.521-130.089,3.872,3.853,1.117,117.3Z"
          transform="translate(-186.983 -709.584)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Panel-3"
          data-name="RHT RR Panel"
          transform="translate(855 474)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(834 474)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_rr_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="130"
          height="18"
          rx="9"
          transform="translate(832 554)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 554)"
        />
        <path
          class="parts"
          id="RHT_RR_Indicator_Lamp-2"
          data-name="RHT Indicator Lamp"
          d="M898.662,1822.374l6.069,2.011s-5.746,1.63-7.044,1.81l-2.561.312-8.6.335v-3.686l7.6.335Z"
          transform="translate(-129.408 -1216.893)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_452"
            data-name="Path 452"
            d="M6157,1021.656l52.177-42H6222"
            transform="translate(-5389.997 -416.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_155"
            data-name="Ellipse 155"
            cx="3"
            cy="3"
            r="3"
            transform="translate(765 602)"
            fill="#696969"
          />
        </g>
        <text
          id="RHT_RR_Indicator_Lamp-3"
          data-name="RHT RR Indicator Lamp"
          transform="translate(855 567)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(834 566)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_door'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_door' | translate"
      >
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="85"
          height="18"
          rx="9"
          transform="translate(832 346)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 346)"
        />
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_444"
            data-name="Path 444"
            d="M6157,979.656l50.57,20.476H6220"
            transform="translate(-5387.997 -644.585)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_149"
            data-name="Ellipse 149"
            cx="3"
            cy="3"
            r="3"
            transform="translate(766 333)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Door-2"
          data-name="RHT Door"
          d="M891.644,807.523l19.321-2.457-.763-89.773s-4.095-1.135-6.161,5.063-11.671,33.43-11.671,45.6Z"
          transform="translate(-133.24 -387.935)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Door-3"
          data-name="RHT Door"
          transform="translate(855 359)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(834 358)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_frt_fender'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_frt_fender' | translate"
      >
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="114"
          height="18"
          rx="9"
          transform="translate(832 317)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 317)"
        />
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_443"
            data-name="Path 443"
            d="M6157,979.656l40.135,12.546H6207"
            transform="translate(-5374.997 -665.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_148"
            data-name="Ellipse 148"
            cx="3"
            cy="3"
            r="3"
            transform="translate(779 311)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_FRT_Fender-2"
          data-name="RHT FRT Fender"
          d="M928.832,446s1.308,3.033,1.175,3.405A4.381,4.381,0,0,1,933,452.9l.6,7.52s2.308-2.308,4.169-1.564v-4.709s3.723-6.031,3.723-9.1l-.077-57.181s-3.781-5.417-7.939-5.863l-5.013-9.288,1.442,68.84S929.688,445.412,928.832,446Z"
          transform="translate(-160.805 -131.499)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_FRT_Fender-3"
          data-name="RHT FRT Fender"
          transform="translate(855 330)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_frt_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(834 329)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['protectives'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.wiper_blades' | translate"
      >
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(832 287)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 287)"
        />
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_442"
            data-name="Path 442"
            d="M6157,992.11l91.511-12.454H6271"
            transform="translate(-5438.997 -684.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_147"
            data-name="Ellipse 147"
            cx="3"
            cy="3"
            r="3"
            transform="translate(715 305)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="Wiper_Blades-2" data-name="Protectives">
          <path
            id="Path_807"
            data-name="Path 807"
            d="M510.012,646.29l-27.771-1.062s-3.648,0-3.127-2.978,6.031-1.787,6.031-1.787Z"
            transform="translate(175.669 -331.793)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_808"
            data-name="Path 808"
            d="M555.587,666.713l38.307-.782S579.7,664.191,571,664.368A59.409,59.409,0,0,0,555.587,666.713Z"
            transform="translate(118.374 -349.858)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_809"
            data-name="Path 809"
            d="M702.294,639.8l-38.418-6.813s-2.233-.6-.818-2.978,7.519,0,7.519,0Z"
            transform="translate(38.259 -323.349)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_810"
            data-name="Path 810"
            d="M766.975,668.856s34.987.973,37.525,6.112Z"
            transform="translate(-39.898 -353.228)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Wiper_Blades-3"
          data-name="Protectives"
          transform="translate(855 300)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.wiper_blades' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(834 299)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_frt_head_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_head_lamp' | translate"
      >
        <g id="Group_106-2" data-name="Group 106" transform="translate(832 227)">
          <rect
            id="Rectangle_38-22"
            data-name="Rectangle 38"
            width="115"
            height="18"
            rx="9"
            transform="translate(0)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 227)"
        />
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_440"
            data-name="Path 440"
            d="M6157,979.656l57.041,4.547h14.016"
            transform="translate(-5396.056 -747.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_145"
            data-name="Ellipse 145"
            cx="3"
            cy="3"
            r="3"
            transform="translate(758 229)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Head_lamp-2"
          data-name="RHT Head lamp"
          d="M779.428,301.57s31.42,12.471,31.866,13.886l5.013,9.288s-1.539-14.388-6.924-17.2c0,0-20.636-9.66-35.235-10.479a4.589,4.589,0,0,0-2.176-.826Z"
          transform="translate(-43.64 -74.241)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Head_lamp-3"
          data-name="RHT Head lamp"
          transform="translate(855 239)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(834 239)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_frt_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="128"
          height="18"
          rx="9"
          transform="translate(832 256)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 256)"
        />
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_441"
            data-name="Path 441"
            d="M6187.58,959.546l40.263,20.11h17.409"
            transform="translate(-5413.252 -714.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_146"
            data-name="Ellipse 146"
            cx="3"
            cy="3"
            r="3"
            transform="translate(770 241)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Indicator_lamp-5"
          data-name="RHT Indicator lamp"
          d="M933.474,363.281l-5.013-9.288V347.71S931.907,350.829,933.474,363.281Z"
          transform="translate(-160.805 -112.778)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Indicator_lamp-6"
          data-name="RHT Indicator lamp"
          transform="translate(855 269)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(834 268)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['frt_grill'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.frt_grill' | translate"
      >
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="85"
          height="18"
          rx="9"
          transform="translate(832 169)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 169)"
        />
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_438"
            data-name="Path 438"
            d="M6157,1022.11l89.905-42.454H6269"
            transform="translate(-5436.998 -801.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_143"
            data-name="Ellipse 143"
            cx="3"
            cy="3"
            r="3"
            transform="translate(717 218)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Grill-2"
          data-name="FRT Grill"
          d="M604.9,297.262h42.29l-8.264-6.031H610.184Z"
          transform="translate(81.454 -70.491)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Grill-3"
          data-name="FRT Grill"
          transform="translate(855 182)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.frt_grill' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(834 181)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['frt_bumper'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.frt_bumpher' | translate"
      >
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(832 198)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 198)"
        />
        <g class="arrow" id="Arrow-22" data-name="Arrow">
          <path
            id="Path_439"
            data-name="Path 439"
            d="M6157,994.11l63.245-14.453h15.542"
            transform="translate(-5403.786 -773.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_144"
            data-name="Ellipse 144"
            cx="3"
            cy="3"
            r="3"
            transform="translate(750 218)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Bumper-2"
          data-name="FRT Bumper"
          d="M397.8,288.2s-6.254,8.041-5.193,24.011c0,0,3.518-5.584,7.818-5.863,0,0,.949-13.513,6.924-17.2,0,0,19.823-9.512,35.235-10.479,0,0,1.377-1.043,8.562-2.085h30.309c7.185,1.042,8.562,2.085,8.562,2.085,15.412.968,35.235,10.479,35.235,10.479,5.975,3.686,6.924,17.2,6.924,17.2,4.3.279,7.818,5.863,7.818,5.863,1.061-15.97-5.193-24.011-5.193-24.011-11.391-14.63-68.5-16.529-68.5-16.529S409.19,273.574,397.8,288.2Z"
          transform="translate(240.492 -55.85)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Bumper-3"
          data-name="FRT Bumper"
          transform="translate(855 210)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.frt_bumpher' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(834 210)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_stop_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="117"
          height="18"
          rx="9"
          transform="translate(832 526)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 526)"
        />
        <g class="arrow" id="Arrow-23" data-name="Arrow">
          <path
            id="Path_451"
            data-name="Path 451"
            d="M6158.042,1049.138l62.2-69.482h15.542"
            transform="translate(-5403.785 -444.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_154"
            data-name="Ellipse 154"
            cx="3"
            cy="3"
            r="3"
            transform="translate(751 602)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Stop_lamp-2"
          data-name="RHT Stop lamp"
          d="M6140.146,3161.925h-16v3.722h10.394l1.029-.92h4.579Z"
          transform="translate(-5383 -2555)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <text
          id="RHT_Stop_lamp-3"
          data-name="RHT Stop lamp"
          transform="translate(855 539)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_stop_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(834 538)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_rht_emblem'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_rr_emblem' | translate"
      >
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="124"
          height="18"
          rx="9"
          transform="translate(832 488)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 488)"
        />
        <g class="arrow" id="Arrow-24" data-name="Arrow">
          <path
            id="Path_449"
            data-name="Path 449"
            d="M6157,1055.656l49.769-76H6219"
            transform="translate(-5386.998 -481.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_153"
            data-name="Ellipse 153"
            cx="3"
            cy="3"
            r="3"
            transform="translate(767 571)"
            fill="#696969"
          />
        </g>
        <rect
          class="parts"
          id="RHT_RR_Emblem-2"
          data-name="RHT RR Emblem"
          width="15.792"
          height="2.599"
          rx="1.3"
          transform="translate(767.617 588.55) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Emblem-3"
          data-name="RHT RR Emblem"
          transform="translate(855 501)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_rr_emblem' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(834 500)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_panel'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="89"
          height="18"
          rx="9"
          transform="translate(661 661)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(732 661)"
        />
        <g class="arrow" id="Arrow-25" data-name="Arrow">
          <path
            id="Path_513"
            data-name="Path 513"
            d="M6158.484,3161v46.6"
            transform="translate(-5453.484 -2547)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_156"
            data-name="Ellipse 156"
            cx="3"
            cy="3"
            r="3"
            transform="translate(702 611)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Panel-2"
          data-name="RR Panel"
          d="M554.082,1849.341h65.761l-3.092-2.923h-3.366l-2.569-3.1H563.463l-3.127,3.559-4-.55Z"
          transform="translate(119.5 -1232.578)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Panel-3"
          data-name="RR Panel"
          transform="translate(681 673)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(734 672)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['logo'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.logo' | translate"
      >
        <rect
          id="Rectangle_38-29"
          data-name="Rectangle 38"
          width="66"
          height="18"
          rx="9"
          transform="translate(497 175)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-29"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(545 175)"
        />
        <ellipse
          class="parts"
          id="Logo-2"
          data-name="Logo"
          cx="5.475"
          cy="2.269"
          rx="5.475"
          ry="2.269"
          transform="translate(701.316 221.524)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-29"
          data-name="3.0"
          transform="translate(547 186)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <text
          id="Logo-3"
          data-name="Logo"
          transform="translate(538 187)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="-27.466" y="0">
            {{ 'exterior.pickup_single_cabin.logo' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-26" data-name="Arrow">
          <circle
            id="Ellipse_142"
            data-name="Ellipse 142"
            cx="3"
            cy="3"
            r="3"
            transform="translate(702 222)"
            fill="#696969"
          />
          <path
            id="Path_422"
            data-name="Path 422"
            d="M6299,1022.11l-113.989-42.454H6157"
            transform="translate(-5593.999 -797.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_r.v_mirror'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.rht_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-30"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(832 376)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-30"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 376)"
        />
        <g class="parts" id="RHT_R.V_Mirror-2" data-name="RHT R.V Mirror">
          <path
            id="Path_815"
            data-name="Path 815"
            d="M946.756,767.64s2.741.224,2.74,0-.023-6.143-.023-6.143l-2.718-3.419Z"
            transform="translate(-174.504 -420.03)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_816"
            data-name="Path 816"
            d="M958.173,777.786l14.351,7.65a6.234,6.234,0,0,0-.447-5.919c-1.954-2.848-10.684-8.934-10.684-8.934s-2.988-1.508-3.83.614v5.417A.99.99,0,0,0,958.173,777.786Z"
            transform="translate(-182.57 -429.003)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g class="arrow" id="Arrow-27" data-name="Arrow">
          <path
            id="Path_445"
            data-name="Path 445"
            d="M6182.76,952.149l27.162,27.507h13.006"
            transform="translate(-5390.929 -595.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_150"
            data-name="Ellipse 150"
            cx="3"
            cy="3"
            r="3"
            transform="translate(788 353)"
            fill="#696969"
          />
        </g>
        <text
          id="RHT_R.V_Mirror-3"
          data-name="RHT R.V Mirror"
          transform="translate(855 389)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.rht_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-30"
          data-name="3.0"
          transform="translate(834 388)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['cabin_roof'] || ''"
        [attr.data-name]="'exterior.pickup_single_cabin.cabin_roof' | translate"
      >
        <rect
          id="Rectangle_38-31"
          data-name="Rectangle 38"
          width="93"
          height="18"
          rx="9"
          transform="translate(832 433)"
          fill="#242e3a"
          opacity="0.07"
        />
        <g class="arrow" id="Arrow-28" data-name="Arrow">
          <path
            id="Path_448"
            data-name="Path 448"
            d="M6157,979.656l102.722,14.018h25.243"
            transform="translate(-5450.963 -550.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_151"
            data-name="Ellipse 151"
            cx="3"
            cy="3"
            r="3"
            transform="translate(704 426)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Cabin_Roof-2"
          data-name="Cabin Roof"
          d="M496.751,880.672s-.035,1.962,5.9.341,41.823-1.918,41.823-1.918,31.647-.032,40.5,1.734c6.178,1.245,7.152-.156,7.152-.156l-1.961,56.982h.614v11.392l-92.688.139V937.654h.614Z"
          transform="translate(162.425 -510.638)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <circle
          id="Ellipse_21-31"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(832 433)"
        />
        <text
          id="Cabin_Roof-3"
          data-name="Cabin Roof"
          transform="translate(855 446)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_single_cabin.cabin_roof' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-31"
          data-name="3.0"
          transform="translate(834 445)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
    </g>
  </svg>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : QC Passed
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : QC Failed
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>

    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part Change Needed)</option>
                <option [value]="2">2 (Major Repair Needed)</option>
                <option [value]="3">3 (Moderate Repair needed)</option>
                <option [value]="4">4 (Minor Repair Needed)</option>
                <option [value]="5">5 (Good Part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <!-- <label class="modal_car_input_label">Description</label> -->
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="!vehicleStatus || editableRole.includes(role)"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="!vehicleStatus || editableRole.includes(role)"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="!vehicleStatus || editableRole.includes(this.role) || role === 'qc'"
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn__primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>